// frontend/src/pages/PaychequeDetail/components/MemoEditor.tsx
// Memo textarea with uppercase label. Save-on-blur handled by parent.

import React from "react";
import { BORDER, TEXT_PRIMARY, TEXT_SECONDARY } from "../styles";

interface MemoEditorProps {
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  placeholder?: string;
}

export default function MemoEditor({
  value,
  onChange,
  onBlur,
  placeholder = "Add a note for this paycheque (saved with the record)",
}: MemoEditorProps): React.ReactElement {
  return (
    <div style={{ marginBottom: 4 }}>
      <label
        style={{
          display: "block",
          fontSize: 10,
          color: TEXT_SECONDARY,
          textTransform: "uppercase",
          letterSpacing: 0.4,
          fontWeight: 500,
          marginBottom: 6,
        }}
      >
        Memo
      </label>
      <textarea
        rows={2}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        placeholder={placeholder}
        style={{
          width: "100%",
          padding: "8px 10px",
          fontSize: 12,
          borderRadius: 5,
          border: "0.5px solid " + BORDER,
          fontFamily: "inherit",
          resize: "vertical",
          boxSizing: "border-box",
          color: TEXT_PRIMARY,
        }}
      />
    </div>
  );
}